<template>
  <div class="rank_container">
    <div class="rank_filter">
      <div class="rank_bread_crumbs">
        <div class="bread_crumbs_before">
          <div class="bread_crumbs_before_left"></div>
          <div class="bread_crumbs_before_right"></div>
        </div>
        <div class="bread_crumb" v-for="(item,ind) in bread_crumbs" :key="ind">
          <span class="bread_crumb_l" v-if="ind>0">></span>
          <span>{{item}}</span>
        </div>
      </div>
      <div class="rank_tabs">
        <div class="rank_tab" :class="show_author == 'all'?'act':''" @click="show_author = 'all';search_val=''">全部({{rank_list.length}})</div>
        <div class="rank_tab" :class="show_author == 'my'?'act':''" @click="show_author = 'my';search_val=''">已授权({{my_car_num}})</div>
        <div class="rank_tab" :class="show_author == 'collect'?'act':''" @click="show_author = 'collect';search_val=''">收藏({{collect_car_num}})</div>
      </div>
      <!-- <div class="rank_childs" v-if="currentNode.name!='按综合得分排序'">
        <div class="rank_selected">
          <div class="rank_icon_rank"></div>
          <div class="rank_select_name">{{ currentNode.name }}</div>
          <div class="rank_icon_select"></div>
        </div>
        <div class="rank_options">
          <div
            class="rank_option"
            v-for="(item, ind) in currentChilds"
            :key="ind"
            @click="changeNodeFn(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div> -->
      <div class="rank_search">
        <input
          type="text"
          v-model="search_val"
          placeholder="输入品牌或车型名称"
          @keyup="searchFn"
        />
        <div class="search_btn" @click="searchFn"></div>
      </div>
    </div>
    <div class="warning_line" v-if="shield_num>0" v-show="shield_show">
      <div class="warning_icon"></div>
      <div class="warning_text">后台设置了屏蔽评测节点，分数为调整后结果，可重新设置调整评测节点显示</div>
      <div class="warning_handle">
        <router-link
          class="warning_btn"
          :to="{
            path:'/setting/ignoreNode'
          }"
        >设置
        </router-link>
        <div class="warning_btn" @click="shield_show=false">
          不再提示
        </div>
      </div>
    </div>
    <div class="rank_list" v-loading="rank_loading">
      <template v-for="item in rank_list" :key="item.model_id">
        <CarItem
          v-if="item.score > 0"
          v-show="
            show_author == 'all' ||
            (show_author == 'my' && item.has_permission == 1) ||
            (show_author == 'collect' && item.is_collect == 1 && item.has_permission == 1) ||
            (show_author == 'result' && ( result_arr && result_arr.indexOf(item.model_id + '')>-1 || result_arr.indexOf(item.model_id*1)>-1))
          "
          :data="item"
          :oldData="old_list[item.short_name] || {}"
          :activeTab="activeTabIdRef"
          :activeId="activeId"
          :activeName="activeName"
          :index="item.rank"
          @openCarAttrDrawer="openCarAttrDrawer"
          @changeCollect="changeCollectFn"
        />
      </template>
    </div>
  </div>

  <div class="compare_box">
    <div class="compare_show_btn" @click.stop="compare_btn_show = !compare_btn_show">
      <div class="compare_num">{{(contrastListRef && contrastListRef.length) || 0 }}</div>
      <div class="compare_text">对比</div>
    </div>
    <div class="compare_list_box" :class="compare_btn_show ? '' : 'hide'">
      <div class="compare_list">
        <template v-if="contrastListRef && contrastListRef.length > 0">
          <div
            class="contrast_item flex_center flex_between"
            v-for="car of contrastListRef"
            :key="car.model_id"
          >
            <span>{{ car.model_name }}</span>
            <el-icon @click.stop="delCompareCar(car)" style="cursor: pointer"
              ><close-bold :color="'#96A6CA'"
            /></el-icon>
          </div>
        </template>
        <button class="to_page_btn" @click.self="toContrastPage">测评对比</button>
        <div
          :class="'show_compare_btn' + (compare_btn_show ? '' : 2)"
          @click.stop="compare_btn_show = !compare_btn_show"
        ></div>
      </div>
    </div>
  </div>
  
  <CarAttr ref="carAttrDrawer" />
</template>

<script>
import { ref, reactive, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getRankDataV2, getRankNodeDataV2, getSearchCarV2} from "@/api";
import { ElIcon, ElMessage } from "element-plus"
import { CloseBold } from "@element-plus/icons";
import store from "@/store";
import CarItem from "@/components/v2/common/views/CarItem.vue";
import CarAttr from "@/components/v2/common/views/CarAttr.vue";
export default {
  name: "Rank",
  components: {
    CarItem,
    CarAttr,
    ElIcon,
    CloseBold
  },

  setup() {
    const route = useRoute();
    const router = useRouter();
    const curDataObj = reactive({
      page: 1,
      size: 99,
      total_page: 1,
      loading: false,
    });
    const rank_type_obj = {
      '0':{
        rank_type:0,
        bread_crumbs:['综合榜单(基础项总分+创新项总分)']
      },
      '0-3':{
        rank_type:3,
        bread_crumbs:['基础项评测']
      },
      '0-2':{
        rank_type:2,
        bread_crumbs:['创新项评测']
      },
      '4922':{
        rank_type:0,
        bread_crumbs:['基础项评测','功能维度','仪表方控']
      },
      '4941':{
        rank_type:0,
        bread_crumbs:['基础项评测','功能维度','内容生态']
      },
      '4963':{
        rank_type:0,
        bread_crumbs:['基础项评测','功能维度','座椅空调']
      },
      '4983':{
        rank_type:0,
        bread_crumbs:['基础项评测','功能维度','座舱安全']
      },
      '5003':{
        rank_type:0,
        bread_crumbs:['基础项评测','功能维度','硬件智控']
      },
      '5036':{
        rank_type:0,
        bread_crumbs:['基础项评测','功能维度','空间应用']
      },
      '5057':{
        rank_type:0,
        bread_crumbs:['基础项评测','功能维度','语音交互']
      },
      '5123':{
        rank_type:0,
        bread_crumbs:['基础项评测','功能维度','车手互联']
      },
      '5165':{
        rank_type:0,
        bread_crumbs:['基础项评测','功能维度','车机系统']
      },
      '5195':{
        rank_type:0,
        bread_crumbs:['基础项评测','功能维度','车载导航']
      },
      '1':{
        rank_type:2,
        bread_crumbs:['创新项评测','数字化创新']
      },
      '2':{
        rank_type:2,
        bread_crumbs:['创新项评测','交互功能创新']
      },
      '3':{
        rank_type:2,
        bread_crumbs:['创新项评测','座舱环境创新']
      },
      '4228':{
        rank_type:4,
        bread_crumbs:['基础项评测','性能维度','智能表现']
      },
      '4481':{
        rank_type:4,
        bread_crumbs:['基础项评测','性能维度','易用性']
      },
      '4520':{
        rank_type:4,
        bread_crumbs:['基础项评测','性能维度','外观']
      },
      '4548':{
        rank_type:4,
        bread_crumbs:['基础项评测','性能维度','可信赖感']
      },
      '4575':{
        rank_type:5,
        bread_crumbs:['基础项评测','旅途维度','准备出发']
      },
      '4600':{
        rank_type:5,
        bread_crumbs:['基础项评测','旅途维度','车中落座']
      },
      '4685':{
        rank_type:5,
        bread_crumbs:['基础项评测','旅途维度','车辆行驶']
      },
      '4760':{
        rank_type:5,
        bread_crumbs:['基础项评测','旅途维度','特殊情况']
      },
      '4779':{
        rank_type:5,
        bread_crumbs:['基础项评测','旅途维度','停车小憩']
      },
      '4828':{
        rank_type:5,
        bread_crumbs:['基础项评测','旅途维度','再次出行']
      },
      '4861':{
        rank_type:5,
        bread_crumbs:['基础项评测','旅途维度','车辆到达']
      },
      '4880':{
        rank_type:5,
        bread_crumbs:['基础项评测','旅途维度','驾乘回忆']
      },
    };
    const bread_crumbs = ref(rank_type_obj[route.params.id].bread_crumbs);
    
    // 计算个数
    const my_car_num = ref(0);
    const collect_car_num = ref(0);
    const countNum = (list)=>{
      let my_num = 0;
      let collect_num = 0;
      list.forEach(item => {
        if(item.has_permission == 1){
          my_num+=1;
          if(item.is_collect == 1){
            collect_num+=1;
          }
        }
      });
      my_car_num.value = my_num;
      collect_car_num.value = collect_num;
    }
    // 获取排行列表数据
    const rank_list = ref([]);
    const old_list = ref({});
    const rank_loading = ref(false);
    const getRankDataV2Fn = (node_id) => {
      rank_list.value = [];
      rank_loading.value = true;
      let rank_type = rank_type_obj[node_id].rank_type;
      bread_crumbs.value=rank_type_obj[route.params.id].bread_crumbs;
      if (node_id == '0' || node_id == '0-3' || node_id == '0-2') {
        getRankDataV2({
          rank_type,
          page: curDataObj.page,
          size: curDataObj.size,
        }).then((res) => {
          rank_list.value = res.data.list;
          old_list.value = res.data.old_list;
          countNum(res.data.list);
          rank_loading.value = false;
        });
      } else {
        getRankNodeDataV2({
          rank_type,
          node_id,
          page: curDataObj.page,
          size: curDataObj.size,
        }).then((res) => {
          rank_list.value = res.data.list;
          old_list.value = res.data.old_list;
          countNum(res.data.list);
          rank_loading.value = false;
        });
      }
    };
    getRankDataV2Fn(route.params.id);
    // 打开车型参数
    const carAttrDrawer = ref(null);
    const openCarAttrDrawer = (model_id) => {
      carAttrDrawer.value.carAttrDrawer = true;
      carAttrDrawer.value.model_id = model_id;
    };
    // 改变收藏
    const changeCollectFn = (type)=>{
      if(type == 'add'){
        collect_car_num.value++;
      }else if(type == 'del'){
        collect_car_num.value--;
      }
    }
    // 搜索车型
    const search_val = ref("");
    const result_arr = ref([]);
    const searchFn = ()=>{
      if(search_val.value.trim()){
        getSearchCarV2({
          keyword:search_val.value.trim()
        }).then(res=>{
          show_author.value = "result";
          result_arr.value = JSON.parse(JSON.stringify(res.data)) || [];
        })
      } else {
        show_author.value = "all";
        getRankDataV2Fn(route.params.id);
      }
    }
    // 全部 已授权 收藏
    const show_author = ref("all");
    watch(()=>route.path,(new_path,old_path)=>{
      if(new_path.indexOf('drive')==-1 && new_path!==old_path && route.path.indexOf('rank')>-1){
        localStorage.setItem("zc_rank_id",route.params.id);
        getRankDataV2Fn(route.params.id);
      }
    })
    const compare_btn_show = ref(false);
    const showOrHideCompare = (isShow)=>{
      compare_btn_show.value = isShow?true:false;
    }
    const contrastListRef = computed(() => store.state.compareCarDataV2);
    showOrHideCompare(false);
    const contrastListIds = ref([]);
    contrastListIds.value =
      (contrastListRef.value &&
        contrastListRef.value.map((item) => {
          return item.model_id;
        })) ||
      [];
    watch(contrastListRef, (new_val) => {
      console.log('new_val', new_val);
      clearTimeDown();
      contrastListIds.value = new_val.map((item) => {
        return item.model_id;
      });
      if(contrastListIds.value.length>0){
        compare_btn_show.value = true;
      }else{
        compare_btn_show.value = false;
      }
    });
    let close_time_down = null;
    const clearTimeDown = ()=>{
      clearTimeout(close_time_down);
      close_time_down = null;
      if(compare_btn_show.value){
        close_time_down = setTimeout(()=>{
          compare_btn_show.value = false;
        },10000)
      }
    }
    clearTimeDown();
    watch(compare_btn_show,()=>{
      clearTimeDown();
    })
    const delCompareCar = (car) => {
      const id = car.model_id;
      store.deleteCompareCarDataV2(id);
    };
    const toContrastPage = () => {
      const data = store.getCompareCarDataV2();
      if (data && data.length > 0) {
        let ids = [];
        for (let item of data) {
          ids.push(item.model_id);
        }
        console.log('location')
        //跳转到测评多个
        router.push({
          path: "/v2/contrast/multi_analyse/index",
          query: {
            model_id: ids.join(","),
          },
        });
      } else {
        ElMessage.error("请先选择车型!");
      }
    };
    const shield_num = ref(store.state.has_review_hide);
    
    watch(()=>store.state.has_review_hide,(new_val)=>{
      shield_num.value = new_val;
      console.log(new_val)
    })
    const shield_show = ref(true);

    return {
      // currentChilds,
      // currentNode,
      // changeNodeFn,
      shield_num,
      shield_show,

      bread_crumbs,

      rank_list,
      old_list,
      rank_loading,
      carAttrDrawer,
      openCarAttrDrawer,
      changeCollectFn,

      search_val,
      searchFn,
      result_arr,
      show_author,

      my_car_num,
      collect_car_num,

      contrastListRef,
      delCompareCar,
      toContrastPage,
      compare_btn_show
    };
  },
};
</script>
<style scoped lang="less">
.rank_container {
  width: 1223px;
  min-height: calc(100vh - 125px);
  background: #ffffff;
  border-radius: 2px;
  padding: 34px 43px;
  position: relative;
  .rank_filter {
    display: flex;
    align-items: center;
    .rank_bread_crumbs{
      height: 46px;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #0E0A31;
      position: relative;
      .bread_crumb{
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
        color: #0E0A31;
        span{
          margin-right: 5px;
          height: 20px;
          line-height: 20px;
        }
        .bread_crumb_l{
          height: 20px;
          line-height: 17px;
        }
      }
      .bread_crumbs_before{
        display: flex;
        align-items: center;
        position: absolute;
        left: 0;
        bottom: 0;
        .bread_crumbs_before_left{
          width: 24px;
          height: 2px;
          background: #1FBCBF;
        }
        .bread_crumbs_before_right{
          width: 38px;
          height: 2px;
          background: #DCDCDC;
        }
      }
    }
    .rank_tabs {
      background: #f0f0f0;
      border-radius: 2px;
      display: flex;
      margin-left: auto;
      margin-right: 34px;
      .rank_tab {
        cursor: pointer;
        width: 90px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        font-size: 14px;
        color: #566169;
        &:nth-child(2) {
          width: 105px;
      
        }
        &.act{
          background: #1FBCBF;
          color: #fff;
        }
      }
    }
    .rank_childs {
      width: 285px;
      height: 38px;
      border-radius: 2px 2px 0 0;
      border: 1px solid #9d9d9d;
      margin-left: 31px;
      cursor: pointer;
      position: relative;
      .rank_selected {
        width: 285px;
        height: 38px;
        display: flex;
        align-items: center;
        padding-right: 10px;
        .rank_icon_rank {
          width: 49px;
          height: 38px;
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/rank_icon_20221228.png)
            no-repeat center center;
          background-size: 16px 14px;
          flex-shrink: 0;
        }
        .rank_select_name {
          flex-grow: 1;
          font-size: 14px;
          color: #36474f;
        }
        .rank_icon_select {
          width: 30px;
          height: 38px;
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/select_20221228.png)
            no-repeat center center;
          background-size: 15px;
          transform: rotateZ(0deg);
          transition: all 300ms;
        }
      }
      .rank_options {
        display: none;
        border: solid 1px #9d9d9d;
        border-top: none;
        position: absolute;
        left: -1px;
        top: 37px;
        width: 285px;
        z-index: 1;
        background: #fff;
        .rank_option {
          width: 100%;
          height: 38px;
          line-height: 38px;
          background: #fff;
          font-size: 15px;
          padding-left: 40px;
          &:hover {
            background: rgba(31, 188, 191, 0.5);
          }
        }
      }
      &:hover {
        .rank_selected {
          .rank_icon_select {
            transform: rotateZ(180deg);
          }
        }
        .rank_options {
          display: block;
        }
      }
    }
    .rank_search {
      width: 210px;
      height: 38px;
      border-radius: 2px;
      background-position: 162px center;
      display: flex;
      align-items: center;
      border: 1px solid #d7d7d7;
      input {
        width: 100%;
        height: 100%;
        appearance: none;
        outline: none;
        border: none;
        background: transparent;
        padding: 0 10px 0 20px;
        font-size: 14px;
        &::placeholder{
          color: #bebebe;
        }
      }
      &:has(input:focus){
        border: 1px solid #1FBCBF;
      }
      .search_btn {
        width: 50px;
        height: 100%;
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ssh_20221229.png)
          no-repeat center center;
        background-size: 17px 17px;
        cursor: pointer;
      }
    }
  }
  .warning_line{
    margin-top: 20px;
    width:100%;
    height: 29px;
    background: #FFF0E1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    padding: 0 23px 0 11px;
    .warning_icon{
      width: 14px;
      height: 14px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/hth_20230131.svg);
      background-size: 14px;
    }
    .warning_text{
      margin-left: 14px;
      font-size: 12px;
      font-weight: 400;
      color: #DB6B6B;
    }
    .warning_handle{
      margin-left: auto;
      display: flex;
      .warning_btn{
        margin-left: 28px;
        font-size: 12px;
        font-weight: 400;
        color: #DB6B6B;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .rank_list {
    // padding: 26px;
    width: 100%;
  }
}
.compare_box{
  position: fixed;
  right: 100px;
  bottom: 270px;
  z-index: 10;
  .compare_show_btn{
    cursor: pointer;
    width: 76px;
    height: 76px;
    border-radius: 50%;
    background: linear-gradient(180deg, #FFFFFF 0%, #F7F7F7 100%);
    box-shadow: 1px 2px 12px 0px rgba(0,0,0,0.07);
    padding-top: 13px;
    text-align: center;
    .compare_num{
      height: 35px;
      font-size: 26px;
      color: #7D7D7D;
      line-height: 35px;
    }
    .compare_text{
      height: 16px;
      font-size: 14px;
      font-weight: bold;
      color: #05A6AA;
      line-height: 16px;
    }
  }
  .compare_list_box{
    position: absolute;
    top: 92px;
    left: 50%;
    transform: translateX(-50%);
    width: 230px;
    padding: 20px 10px 20px 20px;
    background: #fff;
    box-shadow: 1px 2px 12px 0px rgba(0,0,0,0.07);
    border-radius: 5px 0 0 5px;
    font-size: 16px;
    color: #000;
    z-index: 100;
    &.hide{
      display: none;
    }
    .compare_list{
      .contrast_item{
        height: 46px;
        font-size: 14px;
        line-height: 1.2;
        background-color: #f9f9f9;
        border-radius: 5px;
        margin-bottom: 10px;
        padding: 0 10px;
      }
    }
    .to_page_btn {
      display: block;
      margin: 0 auto;
      font-size: 16px;
      color: #000;
      font-weight: bold;
      background: #1FBCBF;
      color: #fff;
      width: 70%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      outline: none;
      border-radius: 4px;
      border: none;
      cursor: pointer;
    }
  }
}
</style>
